import * as imagepaths from "./imagepath";
window.imagepaths = imagepaths;